<template>
  <ImageGallery
      api-endpoint="/api/makeup"
      title="Make-up Gallery"
      subtitle="Professional makeup artistry."
  />
</template>

<script>
import ImageGallery from './ImageGallery.vue';

export default {
  name: 'MakeupGallery',
  components: {
    ImageGallery
  }
};
</script>